import React from "react";
import { Container, Row, Col, Badge, Card, CardHeader, CardBody } from "shards-react";

import PageTitle from "../components/common/PageTitle";

class StateWiseCoronaCases extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      coronaCases: []
    }
  }

  componentDidMount() {
    var stateData = [];
    fetch("https://data.covid19india.org/data.json")
    .then((res) => res.json())
    .then((data) => {
      // console.log("Fetched state wise data:", data.statewise, data.key_values, data.cases_time_series);
      stateData = data.statewise;
      this.setState({
        coronaCases: stateData.splice(1)
      });
      console.log('Any bugs, feel free to raise an issue on GitHub(@vinitshahdeo)');
    })
    .catch(console.log);
  }

  render() {
    return (
    <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="State Wise Report" subtitle="COVID-19 Tracker" className="text-sm-left" />
    </Row>

    {/* Default Light Table */}
    <Row>
      <Col>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Reported corona cases so far...</h6>
          </CardHeader>
          <CardBody className="p-0 pb-3">
            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    State
                  </th>
                  <th scope="col" className="border-0">
                    Confirmed
                  </th>
                  <th scope="col" className="border-0">
                    Active
                  </th>
                  <th scope="col" className="border-0">
                    Recovered
                  </th>
                  <th scope="col" className="border-0">
                    Deaths
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {this.state.coronaCases.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>{data.state}  </td>
                    <td>{data.confirmed}{" "}{data.deltaconfirmed == 0 ? '' :<Badge theme="light" className="deltaconfirmed"><span className="text-primary text-bold">+{data.deltaconfirmed}</span></Badge>}</td>
                        <td>{data.active}</td>
                        <td>{data.recovered}{data.deltarecovered == 0 ? '' :<Badge theme="light" className="deltaconfirmed"><span className="text-success text-bold">+{data.deltarecovered}</span></Badge>}</td>
                        <td>{data.deaths}{data.deltadeaths == 0 ? '' :<Badge theme="light" className="deltaconfirmed"><span className="text-danger text-bold">+{data.deltadeaths}</span></Badge>}</td>
                      </tr>
                    )
                })}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </Col>
    </Row>

  </Container>
    );
  }
}
 

export default StateWiseCoronaCases;
